import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Own_vehicle_list_close = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

   const canView  = hasPermission("Vehicle Closing List", "view");
        const canEntry = hasPermission("Vehicle Closing List", "entry");
  

  // Fetch branches only once
  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/hire_vehicle_close_list")
      .then((response) => {
        setBranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  // Fetch data based on selected branch
  useEffect(() => {
    if (selectedBranch) {
      setLoading(true);
      axios.get(`https://rfs2.infraconsoft.net.in/api/hire_vehicle_close_list?branch_code=${selectedBranch}`)
        .then((response) => {
          setData(response.data.vehicles);
          setFilteredData(response.data.vehicles);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedBranch]);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.fld_vcode && item.fld_vcode.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_vname && item.fld_vname.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_vtype && item.fld_vtype.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate('/own_vehicle_list');
    }
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">{selectedBranch} - Vehicle Closing List</h2>
          <div>
            <Time />
          </div>
        </section>

        
      <div className="vehicle-class">
  {/* Branch Selection (only when HO is selected) */}
  {selectedBranch === "HO" && (
    <div>
      <p><b>Branch wise Report:</b></p>
      <select
        value={selectedBranch}
        onChange={(e) => setSelectedBranch(e.target.value)}
        required
        className="branch-select"
      >
        <option value="">Select Branch</option>
        {branches.map((item) => (
          <option key={item.branchMaster_code} value={item.branchMaster_code}>
            {item.branchMaster_name}
          </option>
        ))}
      </select>
    </div>
  )}

  {/* Vehicle Type Selection */}
  <div>
    <p><b>Select your vehicle:</b></p>
    <select className="branch-select" onChange={handleSelection}>
    
      <option value="/hire">Hire Vehicle</option>
        <option value="/own">Own Vehicle</option>
    </select>
  </div>
</div>


      
        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by vehicleName" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
              <th>S.No</th>
                                <th>Vehicle Code</th>
                                <th>Vehicle Number</th>
                                <th>Vehicle Name</th>
                                <th>Vehicle Type</th>
                                <th>Company</th>
                                <th>Owner</th> 
                                 {canEntry && (
                                <th>Close</th>  
                                 )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.fld_vcode}</td>
                    <td>{item.fld_vehno}</td>
                    <td>{item.fld_vname}</td>
                    <td>{item.fld_vtype}</td>
                    <td>{item.fld_vcompanyname}</td>
                    <td>{item.fld_ownersname}</td>
                     {canEntry && (
                    <td><Link to={`/hire_vehicle_closing/${item.fld_hireid}`}>Close</Link></td>
                     )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>{index + 1}</button>
          ))}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default Own_vehicle_list_close;
